/* --------------------------------------------------------------------------------------------
 * Copyright (c) 2024 TypeFox and others.
 * Licensed under the MIT License. See LICENSE in the package root for license information.
 * ------------------------------------------------------------------------------------------ */
import { BaseLanguageClient } from 'vscode-languageclient/lib/common/client.js';
export class MonacoLanguageClient extends BaseLanguageClient {
    connectionProvider;
    constructor({ id, name, clientOptions, connectionProvider }) {
        super(id ?? name.toLowerCase(), name, clientOptions);
        this.connectionProvider = connectionProvider;
    }
    createMessageTransports(encoding) {
        return this.connectionProvider.get(encoding);
    }
}
//# sourceMappingURL=index.js.map